import * as styles from "./ProgressBar.css";
import { ProgressSegment } from "../elements/ProgressSegment";
import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import clsx from "clsx";

export type ProgressBarProps = {
  total: number;
  numProgressed: number;
  type?: "timeline" | "segments";
  theme?: "colour" | "light";
  fullWidth?: boolean;
} & ComponentPropsWithoutRef<"div">;

export const ProgressBar = ({
  total,
  numProgressed,
  type = "segments",
  theme = "colour",
  fullWidth = false,
  className,
}: ProgressBarProps) => {
  return (
    <>
      {type === "segments" && (
        <div className={clsx(className, styles.bar({ type: "segment" , fullWidth: fullWidth}))}>
          {[...Array(numProgressed < total ? numProgressed : total)].map(
            (item, index) => {
              return (
                <ProgressSegment isCompleted={true} key={index} theme={theme} />
              );
            }
          )}
          {[
            ...Array(total - numProgressed > 0 ? total - numProgressed : 0),
          ].map((item, index) => {
            return (
              <ProgressSegment isCompleted={false} key={index} theme={theme} />
            );
          })}
        </div>
      )}
      {type === "timeline" && (
        <div className={clsx(className, styles.bar({ type: "timeline",  fullWidth: fullWidth }))}>
          <ProgressSegment isCompleted={false} type="round" theme={theme} />
          <ProgressSegment
            isCompleted={true}
            className={styles.progress}
            type="round"
            style={{ width: `${(numProgressed / total) * 100}%` }}
            theme={theme}
          />
        </div>
      )}
    </>
  );
};
